import { render } from "./reviewExercisesView.vue?vue&type=template&id=b9056a2c&scoped=true&ts=true"
import script from "./reviewExercisesView.vue?vue&type=script&lang=ts"
export * from "./reviewExercisesView.vue?vue&type=script&lang=ts"

import "./reviewExercisesView.vue?vue&type=style&index=0&id=b9056a2c&lang=less&scoped=true"
import "./reviewExercisesView.vue?vue&type=style&index=1&id=b9056a2c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9056a2c"]])

export default __exports__